export const Validator = {
  startWithAsteriskRegex: /^\s*\*/,
  validPasswordRegex: /(?=.*\d)(?=.*[A-Z])(?=.*[a-z])(?=.*[^a-zA-Z0-9]).*/,
  oneLowerCaseLetterRegex: /(?=.*[a-z])/,
  oneUpperCaseLetterRegex: /(?=.*[A-Z])/,
  oneSpecialCharacterRegex: /[^a-zA-Z0-9]/,
  oneNumberRegex: /(?=.*\d)/,
  emailRegex:
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
};
